import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import WorkShareByEmailModal from './WorkShareByEmailModal'

import axios from 'axios'
import Modal from 'react-modal'

import FaShare from 'react-icons/fa/share-square-o'
import FaTwitter from 'react-icons/fa/twitter'
import FaMail from 'react-icons/fa/envelope'

@autobind
class WorkSharing extends Component {
  constructor (props) {
    super(props)
    this.state = { visible: false, showMailModal: false }
  }

  toggleShareOptions () {
    this.setState({visible: !this.state.visible})
  }

  shareOnTwitter () {
    let url = window.location.href
    let msg = 'Check out "' + this.props.work.title + '" on @HeyPobble #PobblePower'
    window.open('http://twitter.com/intent/tweet?original_referer=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(msg) + '&url=' + encodeURIComponent(url), 'sharer', 'toolbar=0,status=0,resizable=1,width=626,height=336')
    this.setState({visible: false})
  }

  handleOpenMailModal () {
    this.setState({visible: false, showMailModal: true})
  }

  handleCloseMailModal () {
    this.setState({showMailModal: false})
  }

  openLoginModal () {
    document.querySelectorAll('[login-method] a')[0].click()
  }

  render () {
    return (
      <span className='workShare__container'>
        <div className={this.state.visible ? 'workShare workShare__visible' : 'workShare'}>
          <button className='workShare__btn workShare__btn--twitter' onClick={this.shareOnTwitter}>
            <FaTwitter />
          </button>
          <button className='workShare__btn workShare__btn--mail' onClick={this.props.user.id ? this.handleOpenMailModal : this.openLoginModal}>
            <FaMail />
          </button>
        </div>
        <button className='workStats__action workStats__action--text btn btn-small btn-default' onClick={this.toggleShareOptions}>
          <FaShare /> <span>Share</span>
        </button>
        <Modal isOpen={this.state.showMailModal} contentLabel='Share by email modal' onRequestClose={this.handleCloseMailModal} overlayClassName='modal' className='modal-dialog'>
          <WorkShareByEmailModal onCloseModal={this.handleCloseMailModal} workId={this.props.work.id} workTitle={this.props.work.title} captchaToken={this.props.work.recaptcha_site_key} userName={this.props.user.display_name || this.props.user.first_name}/>
        </Modal>
      </span>
    )
  }
}

export default WorkSharing

WorkSharing.propTypes = {
  work: PropTypes.object,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/work/WorkSharing.js